import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Valtech Custom Code
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
// import { css } from "styled-components"; // Valtech Custom Code

/* Valtech Custom Code */
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import Search from "@store/Components/Icons/Search";
import { useIsSignedIn } from "@store/Hooks/Common";
import { CartLinkProps } from "@store/Overrides/Widgets/Common/CartLink";
import { HeaderSignInProps } from "@store/Overrides/Widgets/Common/HeaderSignIn";
import { COMMON, MENU } from "@store/theme/design";
import { menuMobileButtonIconSizeStyles, siteWidthStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import { WithShellContext } from "@store/Types/Shell";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import updateCssValue, { Operators } from "@store/utilities/updateCssValue";
import styled, { css, withTheme } from "styled-components";
import { connect, ResolveThunks } from "react-redux";
import toggleSearchOpen from "@store/Store/Data/Header/Handlers/ToggleSearchOpen";

const HeaderSignIn = getWidgetComponent("Common/HeaderSignIn");
const CartLink = getWidgetComponent("Common/CartLink");

const StyledContainer = styled(StyledWrapper)<WithShellContext>``;

/* Valtech Custom Code */
const mapDispatchToProps = {
    toggleSearchOpen,
};

interface OwnProps {
    theme: BaseTheme;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & PageProps;
/* Valtech Custom Code */

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    menuWrapper?: InjectableCss;
    actionWrapper?: InjectableCss;
    clickableOpenSearch?: ClickablePresentationProps;
    iconOpenSearch?: IconPresentationProps;
}

/* Valtech Custom Code */
export const SMALLEST_HEADER_HEIGHT = 58;
export const MAIN_NAV_HEIGHT = [null, SMALLEST_HEADER_HEIGHT, 80, 100, 146];
const subWrapperStyles = () => css`
    display: flex;
    align-items: center;
    height: 100%;
`;

const zoneWrapperStyles = () => css`
    ${subWrapperStyles()}

    > div {
        ${subWrapperStyles()}
    }
`;
const mobileWidthStyles = () => polyfillCss`
    ${props =>
        breakpointMediaQueries(
            props.theme,
            [
                polyfillCss`
                    max-width: 100%;
                    margin: 0 auto;
                    padding-right: ${COMMON.spacing.side[0]};
                    padding-left: ${COMMON.spacing.side[0]};
                    background-color: ${getColor("common.background")};
                    border-bottom: 1px solid ${getColor("common.border")};
                `,
                null,
            ],
            mediaOptions.max,
        )}
`;
/* Valtech Custom Code */

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css<WithShellContext>`
            transition: height ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            pointer-events: none;
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            background-color: transparent;
                        `,
                        polyfillCss`
                        border-bottom: 1px solid ${getColor("common.border")};
                        background-color: ${getColor("common.background")};
                    `,
                        null,
                    ],
                    mediaOptions.min,
                )}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: MAIN_NAV_HEIGHT, properties: ["height"], unit: "px" }],
                    mediaOptions.min,
                )}
            ${props => (props.shellContext?.isEditing ? "height: auto !important;" : null)}
        `,
    },
    wrapper: {
        css: css`
            position: relative;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            height: inherit;
            transform: translateZ(0);
            z-index: 1000;

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        polyfillCss`
                            flex-wrap: nowrap;
                            ${siteWidthStyles()}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    innerWrapper: {
        css: css<WithShellContext>`
            ${subWrapperStyles()}
            ${mobileWidthStyles()}
            flex-grow: 1;
            height: 50px;
            padding-top: 10px;
            margin-left: -${MENU.mobileButtonSpacing};
            pointer-events: all;
            ${props => (props.shellContext?.isEditing ? "height: auto !important;" : null)}

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css``,
                        css`
                            height: 100%;
                            padding-top: 0;
                        `,
                        null,
                        css`
                            flex: 0 1 50%;
                            margin-left: 0;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    menuWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            flex-grow: 1;
        `,
    },
    actionWrapper: {
        css: css`
            ${subWrapperStyles()}
            margin-left: ${MENU.mobileButtonSpacing};
            margin-right: -${MENU.mobileButtonSpacing};
            pointer-events: all;
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        null,
                        css`
                            margin-left: 1em;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    logoWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            flex: 0 0 auto;
            height: 76%;
            pointer-events: all;
        `,
    },
    searchMenuWrapper: {
        css: css`
            ${zoneWrapperStyles()}
            ${mobileWidthStyles()}
            padding-bottom: 10px;
            pointer-events: all;
            transition: opacity ${getProp("theme.transition.duration.regular")}ms ease-in-out,
                visibility ${getProp("theme.transition.duration.regular")}ms ease-in-out;

            > div {
                justify-content: flex-end;
            }

            opacity: 0;
            visibility: hidden;

            &.isSearchOpen {
                opacity: 1;
                visibility: visible;
            }

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        polyfillCss`
                            flex-basis: 100%;
                            margin-top: -1px;
                            padding-top: 1px;
                        `,
                        css`
                            padding-bottom: 0;
                            margin-left: ${updateCssValue(MENU.mobileButtonSpacing, Operators.Multiply, 2)};
                            opacity: 1;
                            visibility: visible;
                        `,
                        css`
                            margin-left: 1em;
                        `,
                        css`
                            flex: 0 1 50%;
                        `,
                    ],
                    mediaOptions.min,
                )}

            [data-widget] {
                width: 100%;
            }
        `,
    },
    linkListHidden: {},
    clickableOpenSearch: {
        css: css`
            opacity: 1;
            visibility: visible;
            display: inline-flex;
            height: 100%;
            padding: 0 0.5em;
            outline-offset: -1px;
            transition: opacity ${getProp("theme.transition.duration.regular")}ms ease-in-out,
                visibility ${getProp("theme.transition.duration.regular")}ms ease-in-out;

            &.isSearchOpen {
                visibility: hidden;
                pointer-events: none;
                opacity: 0;
            }
        `,
    },
};

/* Valtech Custom Code */
const titleClickableStyles = () => {
    return css`
        height: 100%;
        padding: 0 ${MENU.mobileButtonSpacing};
        outline-offset: -${props => props.theme.focus?.width};
        color: inherit;
    `;
};

const headerSignInProps: HeaderSignInProps = {
    fields: {
        visibilityState: "icon",
        icon: "User",
        includeAccountMenu: true,
    },
    extendedStyles: {
        popover: {
            contentBodyProps: {
                css: css`
                    position: fixed !important; /* Required to override positionFunction */
                    width: 100%;
                `,
            },
        },
        signOutWrapper: {
            css: css`
                height: 100%;
            `,
        },
        titleClickable: {
            css: css`
                ${titleClickableStyles()}
            `,
        },
        titleClickableLoginOnly: {
            css: css`
                ${titleClickableStyles()}
            `,
        },
        titleIcon: {
            css: css`
                ${menuMobileButtonIconSizeStyles()}
            `,
        },
    },
};

/* Valtech Custom Code */
const LogoLinksSearch: React.FC<Props> = ({ id, theme }) => {
    const shellContext = React.useContext(ShellContext);
    const isSignedIn = useIsSignedIn(); // Valtech Custom Code

    /* Valtech Custom Code */
    const [isSearchOpen, setIsSearchOpen] = React.useState(false);
    const [beginScrollTop, setBeginScrollTop] = React.useState(-1);
    const [currentScrollTop, setCurrentScrollTop] = React.useState(0);

    const cartLinkProps: CartLinkProps = {
        fields: {
            visibilityState: "icon",
            icon: "cart",
        },
        extendedStyles: {
            routerLink: {
                icon: {
                    iconProps: {
                        css: css`
                            ${menuMobileButtonIconSizeStyles()}
                            margin-right: 0;
                        `,
                    },
                },
                css: css`
                    height: 100%;
                    padding: 0 ${MENU.mobileButtonSpacing};
                    outline-offset: -${props => props.theme.focus?.width};
                `,
            },
        },
        theme,
    };

    const onShowSearch = () => {
        setIsSearchOpen(true);
        setBeginScrollTop(currentScrollTop);
    };

    const handleScroll = () => {
        setCurrentScrollTop(document.body.scrollTop || document.documentElement.scrollTop);
    };

    React.useEffect(() => {
        const searchInputHasFocus =
            document.activeElement?.getAttribute("data-test-selector") === "headerSearchInputTextField";

        if (currentScrollTop <= 50) {
            setIsSearchOpen(true);
        } else if (!searchInputHasFocus) {
            if ((beginScrollTop > -1 && Math.abs(currentScrollTop - beginScrollTop) > 100) || beginScrollTop === -1) {
                setIsSearchOpen(false);
                setBeginScrollTop(-1);
            }
        }
    }, [currentScrollTop]);

    React.useEffect(() => {
        toggleSearchOpen(isSearchOpen);
    }, [isSearchOpen]);

    React.useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return function cleanup() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    /* Valtech Custom Code */

    return (
        <StyledContainer
            {...logoLinksSearchStyles.container}
            shellContext={shellContext}
            data-test-selector="LogoLinkSearch" // Valtech Custom Code
        >
            <StyledWrapper {...logoLinksSearchStyles.wrapper}>
                <StyledContainer {...logoLinksSearchStyles.innerWrapper} shellContext={shellContext}>
                    <StyledWrapper {...logoLinksSearchStyles.menuWrapper}>
                        <Zone contentId={id} zoneName="LinkList" />
                    </StyledWrapper>
                    <Hidden above="xs" {...logoLinksSearchStyles.actionWrapper}>
                        {/* Valtech Custom Code */}
                        <Clickable
                            {...logoLinksSearchStyles.clickableOpenSearch}
                            data-test-selector="header_showSearch"
                            onClick={onShowSearch}
                            className={isSearchOpen ? "isSearchOpen" : ""}
                            aria-hidden={isSearchOpen}
                        >
                            <Icon {...logoLinksSearchStyles.iconOpenSearch} src={Search} />
                            <VisuallyHidden>{translate("Show search")}</VisuallyHidden>
                        </Clickable>
                        {/* Valtech Custom Code */}
                        <HeaderSignIn {...headerSignInProps} />
                        {isSignedIn && <CartLink {...cartLinkProps} />}
                    </Hidden>
                </StyledContainer>
                <Hidden below="lg" {...logoLinksSearchStyles.logoWrapper}>
                    <Zone contentId={id} zoneName="Logo" />
                </Hidden>
                {/* Valtech Custom Code */}
                <Hidden below="sm" {...logoLinksSearchStyles.searchMenuWrapper}>
                    <Zone contentId={id} zoneName="Search" />
                </Hidden>
                <Hidden
                    above="xs"
                    {...logoLinksSearchStyles.searchMenuWrapper}
                    // Valtech Custom Code
                    className={isSearchOpen ? "isSearchOpen" : ""}
                    aria-hidden={!isSearchOpen}
                >
                    <Zone contentId={id} zoneName="Search" />
                </Hidden>
                {/* Valtech Custom Code */}
                <Hidden below="sm" above="sm" {...logoLinksSearchStyles.actionWrapper}>
                    <HeaderSignIn {...headerSignInProps} />
                    {isSignedIn && <CartLink {...cartLinkProps} />}
                </Hidden>
            </StyledWrapper>
        </StyledContainer>
    );
};
/* Valtech Custom Code */

const logoLinksSearch: WidgetModule = {
    component: connect(null, mapDispatchToProps)(withTheme(LogoLinksSearch)), // Valtech Custom Code
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
